import {
  campaignsResourcesQuery,
  communitiesResourcesQuery,
  courseBundlesResourcesQuery,
  coursesResourcesQuery,
  emailsResourcesQuery,
  specificEmailsResourcesQuery,
  tagsResourcesQuery,
} from 'src/editor/api/queries/resources-queries'
import { AutomationRuleActionsEnum } from 'src/editor/shared/types/automation-rules/actions-types'

type useResourcesProps = {
  actionType: AutomationRuleActionsEnum | undefined
}

export const useResources = ({ actionType }: useResourcesProps) => {
  const tagsResourcesQueryResult = tagsResourcesQuery.useQuery({
    options: {
      enabled:
        actionType === AutomationRuleActionsEnum.add_tag ||
        actionType === AutomationRuleActionsEnum.remove_tag,
    },
  })

  const campaignsResourcesQueryResult = campaignsResourcesQuery.useQuery({
    options: {
      enabled:
        actionType === AutomationRuleActionsEnum.subscribe_to_campaign ||
        actionType === AutomationRuleActionsEnum.unsubscribe_from_campaign,
    },
  })

  const emailsResourcesQueryResult = emailsResourcesQuery.useQuery({
    options: {
      enabled: actionType === AutomationRuleActionsEnum.send_email,
    },
  })

  const specificEmailsResourcesQueryResult =
    specificEmailsResourcesQuery.useQuery({
      options: {
        enabled:
          actionType ===
          AutomationRuleActionsEnum.send_email_to_specific_address,
      },
    })

  const coursesResourcesQueryResult = coursesResourcesQuery.useQuery({
    options: {
      enabled:
        actionType === AutomationRuleActionsEnum.enroll_in_course ||
        actionType === AutomationRuleActionsEnum.revoke_access_to_course,
    },
  })

  const courseBundlesResourcesQueryResult =
    courseBundlesResourcesQuery.useQuery({
      options: {
        enabled:
          actionType === AutomationRuleActionsEnum.enroll_in_course_bundle ||
          actionType ===
            AutomationRuleActionsEnum.revoke_access_to_course_bundle,
      },
    })

  const communitiesResourcesQueryResult = communitiesResourcesQuery.useQuery({
    options: {
      enabled:
        actionType === AutomationRuleActionsEnum.grant_access_to_community ||
        actionType === AutomationRuleActionsEnum.revoke_access_to_community,
    },
  })

  return {
    tagsResourcesQueryResult,
    campaignsResourcesQueryResult,
    emailsResourcesQueryResult,
    specificEmailsResourcesQueryResult,
    coursesResourcesQueryResult,
    courseBundlesResourcesQueryResult,
    communitiesResourcesQueryResult,
  }
}
